import { render, staticRenderFns } from "./VMembersTabs.vue?vue&type=template&id=7996d76d"
import script from "./VMembersTabs.vue?vue&type=script&lang=js"
export * from "./VMembersTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports